const BACKEND_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

async function parseJsonOrThrow(response, fallbackMessage) {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const message = data?.error || fallbackMessage || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export async function checkBackendHealth() {
  try {
    const response = await fetch(`${BACKEND_URL}/api/health`);
    return response.ok;
  } catch (_) {
    return false;
  }
}

export async function fetchNftsByOwner(walletAddress) {
  const response = await fetch(
    `${BACKEND_URL}/api/get-nfts?wallet_address=${encodeURIComponent(walletAddress)}`
  );
  const data = await parseJsonOrThrow(response, 'Failed to fetch NFTs');
  return Array.isArray(data?.nfts) ? data.nfts : Array.isArray(data) ? data : [];
}

export async function fetchCollectionsByOwner(walletAddress) {
  const response = await fetch(
    `${BACKEND_URL}/api/get-collections?wallet_address=${encodeURIComponent(walletAddress)}`
  );
  const data = await parseJsonOrThrow(response, 'Failed to fetch collections');
  return Array.isArray(data?.collections) ? data.collections : Array.isArray(data) ? data : [];
}

